import styled from "styled-components";

export const CertificateDetailContainerStyled = styled.div``;
